export default __webpack_public_path__ + "static/media/Find.a1afae57.jpg";